/**
 * Prøveperiode-status (UX-prinsipp #6 tapsaversjon, grep A — se
 * docs/plan-ux-principles-retention.md). Ærlig tapsramme nær prøveslutt: minne
 * brukeren om at premium-funksjonene forsvinner når prøven utløper, mens det ennå
 * er tid til å beholde dem. Sann og hjelpsom — innenfor gissel-grensen (holder ingenting
 * som gissel; premium-bekvemmeligheter er noe man reelt mister ved prøveslutt).
 *
 * MERK: den planlagte PERSONALISERINGEN («du mister [funksjoner du faktisk brukte]») er
 * IKKE gjennomførbar nå — feature-bruk logges kun som globalt aggregat (usage_stats/{dato}),
 * ikke per bruker. Dette er den ærlige generiske varianten. Personalisering krever ny
 * per-bruker-sporing (egen jobb).
 *
 * Ren og tidsuavhengig (now injiseres) → fullt testbar. Prøvelengden (7 dager) speiler
 * isWithinTrialPeriod i services/accessControl.ts.
 */

const MS_PER_DAY = 24 * 60 * 60 * 1000;

export const TRIAL_DAYS = 7;
export const TRIAL_EXPIRING_SOON_DAYS = 2;

export interface TrialStatus {
  /** Hele dager igjen av prøven (opprundet), 0 når utløpt/ukjent. */
  daysLeft: number;
  isActive: boolean;
  /** Aktiv OG ≤ terskel igjen — da er tapsrammen relevant. */
  isExpiringSoon: boolean;
}

export function getTrialStatus(
  creationTimestamp: number | undefined | null,
  now: number,
  trialDays: number = TRIAL_DAYS,
): TrialStatus {
  if (!creationTimestamp || creationTimestamp <= 0) {
    return { daysLeft: 0, isActive: false, isExpiringSoon: false };
  }
  const msLeft = (creationTimestamp + trialDays * MS_PER_DAY) - now;
  const isActive = msLeft > 0;
  const daysLeft = isActive ? Math.ceil(msLeft / MS_PER_DAY) : 0;
  const isExpiringSoon = isActive && daysLeft <= TRIAL_EXPIRING_SOON_DAYS;
  return { daysLeft, isActive, isExpiringSoon };
}
